import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Link, useOutletContext } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate, useParams } from "react-router-dom";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import MpgFileUpload from "../../../../../fileHandling/MpgFileUpload";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

import ClientTeamDialog from "../../ClientTeamDialog";
import AccountAdminsDialog from "../../AccountAdminsDialog";
import AccountTeamMemberDialog from "../../AccountTeamMemberDialog";

import { useViewAccountTeamMembersListQuery } from "../../../../../reactQueries/AppApi/rqHooksForAccountTeamMembers";
import MpgAutocompleteSingle from "../../../../../CommonFormComp/MpgAutocompleteSingle";
import MpgAutocompleteMulti from "../../../../../CommonFormComp/MpgAutocompleteMulti";
import { useFileDownloadMutation } from "../../../../../reactQueries/commonRQHooks";
import {
  useUploadLogoOfClientSubAccountMutation,
  useUpdateClientSubAccountByIdMutation,
  useDeleteClientSubAccountByIdMutation,
  useGetClientUsersByClientSubAccountIdQuery,
  useGetClientUsersIncludingParentUsersByClientSubAccountIdQuery,
  useGetClientCodeListByClientAccountIdQuery,
} from "../../../../../reactQueries/AppApi/rqHooksForClientSubAccount";
import CircularProgress from "@mui/material/CircularProgress";
import ViewAllClientUserForNotiDialog from "../../viewAllUser/ViewAllClientUserForNotiDialog";
import { editClientSubAccValidation } from "./editClientSubAccValidation";
import ClientTeamTable from "../../accountTableComp/ClientTeamTable";
import AccountTeamTable from "../../accountTableComp/AccountTeamTable";
import AccountAdminTable from "../../accountTableComp/AccountAdminTable";
import { useGetClientAccountDropdownMutation } from "../../../../../reactQueries/AppApi/rqHooksForClientUsers";
import Stack from "@mui/material/Stack";
import { clientSubAccountViewPath } from "../../../../../routes/routePaths";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import MpgSuccessDialog from "../../../../../common/dialog/MpgSuccessDialog";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import { saveAs } from "file-saver";
import MuiLink from "@mui/material/Link";
import MpgConfirmDialogForAccAndSubAccount from "../../../../../common/dialog/MpgConfirmDialogForAccAndSubAccount";
import WarningAlert from "../../../../../common/dialog/alerts/WarningAlert";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import useTrackUserActivity from "../../../../../userActivityTracking/useTrackUserActivity";
import { getGUIDAndExtentionFromFileURL } from "../../../../../hooksAndFunctions/functions/getGUIDAndExtentionFromFileURL";
import { useGetAccountAndSubAccListOnlyForA4Role } from "../../../../../hooksAndFunctions/customHooks/useGetAccountAndSubAccListOnlyForA4Role";
import { getAccessTypes } from "../../../../../hooksAndFunctions/functions/getAccessTypes";
import { useGetClientAccountByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForClientAccount";
import MpgClientCodeTransferListDialogForClientSubAcc from "../../../../../CommonFormComp/MpgClientCodeTransferListForClientSubAcc/MpgClientCodeTransferListDialogForClientSubAcc";

import {
  mapLangListToAutocomplete,
  mapCurrencyListToAutocomplete,
  mapClientTypeListToAutocomplete,
  setClientCodes,
} from "../../../../../common/utilities/Helper";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const EditClientSubAccount = ({
  clientSubAccountDataById,
  LangList,
  CurrencyList,
  ClientTypeList,
  accountAdminListFromAPI,
}) => {
  const { refClientAccountCmsData } = useOutletContext();
  const { id: clientSubAccountId } = useParams();

  const { loggedInUser } = useGetLoggedInUserDetails();
  const {
    clientPortalAdminRoleId,
    isEnterpriseAdmin,
    id: userId,
  } = loggedInUser;

  const { clientPortalAdminType } = getAccessTypes();
  const { hasA2Access, hasA4Access } = clientPortalAdminType;
  /**useful for only A4 role */
  const { clientAccountIdListForA4Role, clientSubAccountIdListForA4Role } =
    useGetAccountAndSubAccListOnlyForA4Role({ userId });

  let navigate = useNavigate();

  const userName = JSON.parse(window.sessionStorage.getItem("UserAccount"))?.[
    "name"
  ];

  /** !!!!!!!! form handling !!!!!!! */
  const { schema } = editClientSubAccValidation();

  const rhfFormInstance = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      client_sub_acc_name: clientSubAccountDataById?.ClientAccountName,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const { setValue, watch } = rhfFormInstance;

  const parentId = clientSubAccountDataById?.ParentID;

  const selectedClientAcc = watch("client_acc_name");
  const selectedPrimaryLang = watch("primary_lang");

  const selectedClientAccId = selectedClientAcc?.id;

  /** !!!!!!!! table state handling !!!!!!! */
  const [clientTeamTableData, setClientTeamTableData] = React.useState([]);
  const [accountTeamMemberTableData, setAccountTeamMemberTableData] =
    React.useState([]);
  const [accountAdminTableData, setAccountAdminTableData] = React.useState([]);

  /** !!!!!!!! dialog state handling !!!!!!! */
  const [openClientTeamDialog, setOpenClientTeamDialog] = React.useState(false);
  const [openAccountTeamDialog, setOpenAccountTeamDialog] =
    React.useState(false);
  const [openAccountAdminDialog, setOpenAccountAdminDialog] =
    React.useState(false);

  const [openClientAccCodeDialog, setOpenClientAccCodeDialog] = useState(false);
  const [wasAdminEdited, setWasAdminEdited] = useState(false);

  const [openAllClientUserNotiDialog, setOpenAllClientUserNotiDialog] =
    useState(false);

  /** !!!!!!!! all API state handling !!!!!!! */
  const {
    mutate: downloadLogo,
    isError: isErrorOnDownload,
    isSuccess: isSuccessOnDownload,
    data: dataOnDownload,
  } = useFileDownloadMutation();
  /**client code list */
  const {
    isSuccess: isSuccessOnClientCodeList,
    data: clientCodeListData,
    isFetching: isFetchingOnClientCodeList,
  } = useGetClientCodeListByClientAccountIdQuery({
    clientAccountId: !!selectedClientAccId ? selectedClientAccId : "",
  });

  /**API calls to UpdateTeamMember */
  const {
    mutate: updateClientSubAccount,
    isError: isErrorOnUpdateCA,
    isLoading: isLoadingOnUpdateCA,
    isSuccess: isSuccessOnUpdateCA,
    error: errorOnUpdateCA,
  } = useUpdateClientSubAccountByIdMutation();

  const {
    mutate: uploadLogo,
    isError: isErrorOnLogoUpload,
    isLoading: isLoadingOnLogoUpload,
    isSuccess: isSuccessOnLogoUpload,
    data: dataOnLogoUpload,
  } = useUploadLogoOfClientSubAccountMutation();

  const {
    mutate: deleteClientSubAccountById,
    isError: isErrorOnDeleteCA,
    isLoading: isLoadingOnDeleteCA,
    isSuccess: isSuccessOnDeleteCA,
    variables: variablesOnDeleteCA,
  } = useDeleteClientSubAccountByIdMutation();

  const { data: accountTeamMembersList } = useViewAccountTeamMembersListQuery();

  /**client user list to display in client teams users dialog */
  const { data: dataOnGetClientUsers, refetch: refetchOnGetClientUsers } =
    useGetClientUsersByClientSubAccountIdQuery({ clientSubAccountId });

  const { data: dataOnClientUsersWithParentUsers } =
    useGetClientUsersIncludingParentUsersByClientSubAccountIdQuery({
      clientSubAccountId,
    });

  const { data: dataOnClientAccountById } = useGetClientAccountByIdQuery({
    clientAccountId: !!selectedClientAccId ? selectedClientAccId : "",
  });

  // console.log("zzz", dataOnClientUsersWithParentUsers)

  /**get list of all client accounts */
  const { mutate: getClientAccountList, data: clientAccountList } =
    useGetClientAccountDropdownMutation();

  useEffect(() => {
    getClientAccountList({
      loggedInUserId: userId,
      roleId: clientPortalAdminRoleId,
      isEnterpriseAdmin,
    });
  }, [loggedInUser]);

  const clientAccListFromAPI = clientAccountList?.data;

  /** !!!!!!!! autocomplete option lists !!!!!!! */
  const primaryLangAutocompleteList = mapLangListToAutocomplete(LangList);

  const currencyAutocompleteList = mapCurrencyListToAutocomplete(CurrencyList);

  const ClientTypeAutocompleteList =
    mapClientTypeListToAutocomplete(ClientTypeList);

  const [supportiveLangAutocompleteList, setSupportiveLangAutocompleteList] =
    useState([]);
  /**supportive lang list should not contain option selected in prim lang */
  useEffect(() => {
    if (selectedPrimaryLang?.id) {
      setSupportiveLangAutocompleteList(
        mapLangListToAutocomplete(
          LangList?.filter((item) => item.Id !== selectedPrimaryLang.id)
        )
      );
    }
  }, [selectedPrimaryLang, LangList]);

  const clientAccAutocompleteList =
    !!clientAccListFromAPI &&
    clientAccListFromAPI.map((item) => {
      const disableOptionForA4Role = !clientAccountIdListForA4Role.includes(
        item?.Id
      );

      let disableOption = false;

      /**disable option is client sub acc is Inactive */
      if (!item.IsActive) {
        disableOption = true;
      } else {
        /**(only for A2/A4 role) get all clinet sub acc ids where this user is not A4 admin and diable those autocomplete options */
        if ((!!hasA4Access || !!hasA2Access) && !!disableOptionForA4Role) {
          disableOption = true;
        } else {
          /**for rest of roles */
          disableOption = false;
        }
      }
      return {
        id: item.Id,
        selectOptionLabel: `${item.ClientAccountName}`,
        selectOptionValue: item.Id,
        selectOptionDisabled: !!disableOption,
        extraData: item,
      };
    });

  /** !!!!!!!! setting existing client account !!!!!!! */
  useEffect(() => {
    if (!!clientSubAccountDataById) {
      const existingAccClientObj = {
        id: clientSubAccountDataById?.ParentID,
        selectOptionLabel: `${clientSubAccountDataById?.ParentAccountName}`,
        selectOptionValue: clientSubAccountDataById?.ParentID,
        extraData: clientSubAccountDataById?.ParentID,
      };

      setValue("client_acc_name", existingAccClientObj || "", {
        shouldValidate: true,
      });
    }
  }, [clientSubAccountDataById]);

  /** !!!!!!!! compute primary and supportive langs !!!!!!! */
  /**clearing prim and supportive langs if client acc is not selected */
  useEffect(() => {
    if (!selectedClientAcc) {
      setValue("primary_lang", "");
      setValue("supported_lang", []);
    }
  }, [selectedClientAcc]);

  useEffect(() => {
    rhfFormInstance.setValue("accountAdmins", accountAdminTableData, {
      shouldValidate: true,
      shouldTouch: true,
    });
    rhfFormInstance.trigger("accountAdmins");
  }, [accountAdminTableData]);
  /**get languages values */
  const clientSubAccLangList = clientSubAccountDataById?.AccountLanguages;

  const [existingPrimLang, setExistingPrimLang] = useState({});
  const [existingSupportedLang, setExistingSupportedLang] = useState([]);

  useEffect(() => {
    if (!!clientSubAccLangList && !!clientSubAccLangList.length) {
      let prim = {};
      let supportive = [];

      clientSubAccLangList.forEach((eachLang) => {
        const foundLang =
          !!LangList &&
          LangList.find((item) => item.Id === eachLang.LanguageID);

        if (!!foundLang) {
          if (!!eachLang.IsPrimary) {
            prim = foundLang;
          } else {
            supportive.push(foundLang);
          }
        }
      });
      setExistingPrimLang(prim);
      setExistingSupportedLang(supportive);
    } else {
      setExistingPrimLang([]);
      setExistingSupportedLang([]);
    }
  }, [clientSubAccLangList, LangList]);

  /**setting prim lang default*/
  useEffect(() => {
    if (!!existingPrimLang.Id) {
      const existingPrimLangDefaultList = {
        id: existingPrimLang.Id,
        selectOptionLabel: `${existingPrimLang.LanguageCode}-${existingPrimLang.LanguageDescription}`,
        selectOptionValue: existingPrimLang.Id,
      };
      setValue("primary_lang", existingPrimLangDefaultList || "", {
        shouldValidate: true,
      });
    }
  }, [existingPrimLang]);

  /**setting supported lang default*/
  useEffect(() => {
    if (!!existingSupportedLang.length) {
      const existingSupportLangDefaultList =
        !!existingSupportedLang &&
        existingSupportedLang.map((item) => {
          return {
            id: item.Id,
            selectOptionLabel: `${item.LanguageCode}-${item.LanguageDescription}`,
            selectOptionValue: item.Id,
          };
        });
      setValue("supported_lang", existingSupportLangDefaultList || [], {
        shouldValidate: true,
      });
    }
  }, [existingSupportedLang]);
  useEffect(() => {
    setValue("created_by", clientSubAccountDataById?.CreatedBy || "");
    setValue(
      "created_date",
      clientSubAccountDataById?.CreatedTimestamp
        ? new Date(clientSubAccountDataById.CreatedTimestamp).toLocaleDateString(
            "en-GB",{
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }
          )
        : ""
    );
  }, [setValue, clientSubAccountDataById]);

  /** !!!!!!!!! filtering Admin list on Permissions !!!!!!!!!! */
  /**for client sub-accounts, admins with only A1 A2 and A4 permisions allowed */
  const [filteredAdminListArr, setFilteredAdminListArr] = useState([]);
  useEffect(() => {
    if (!!accountAdminListFromAPI && !!accountAdminListFromAPI.length) {
      let newListArr = [];
      const regEx = /A1|A2|A4|Enterprise Admin/;
      accountAdminListFromAPI.forEach((item) => {
        if (item?.permissionRole.search(regEx) !== -1) {
          newListArr.push(item);
        }
      });
      setFilteredAdminListArr(newListArr);
    }
  }, [accountAdminListFromAPI]);

  /** !!!!!!! grabing data from client code transfer list !!!!!! */
  const [finalCodeList, setFinalCodeList] = useState([]);

  useEffect(() => {
    /**adding existing codes to final list which is in right table */
    if (!!clientSubAccountDataById?.ClientAccountCodes) {
      const existingCodeList = clientSubAccountDataById?.ClientAccountCodes.map(
        (item) => {
          return {
            clientCode: item.clientCode,
            clientCodeName: item.clientCodeName,
          };
        }
      );
      setFinalCodeList(existingCodeList);
    }
  }, [clientSubAccountDataById?.ClientAccountCodes]);

  /**setting default in Currency Dropdown */
  useEffect(() => {
    if (!!clientSubAccountDataById?.CurrencyId && !!CurrencyList) {
      const existingCurrencyDefaultList =
        !!CurrencyList &&
        CurrencyList.filter(
          (item) => item.Id == clientSubAccountDataById?.CurrencyId
        ).map((item) => {
          return {
            id: item.Id,
            selectOptionLabel: `${item.CurrencyCode}`,
            selectOptionValue: item.Id,
          };
        });
      setValue("CurrencyId", existingCurrencyDefaultList[0] || "", {
        shouldValidate: true,
      });
    } else {
      setValue("CurrencyId", "");
    }
  }, [clientSubAccountDataById?.CurrencyId, CurrencyList]);

  useEffect(() => {
    if (clientSubAccountDataById?.DataClassificationKey && ClientTypeList) {
      const existingClientTypeDefaultList = ClientTypeList.filter(
        (item) =>
          item.DataClassificationKey ==
          clientSubAccountDataById.DataClassificationKey
      ).map((item) => ({
        id: item.DataClassificationKey,
        selectOptionLabel: `${item.MasterDataClassificationName}`,
        selectOptionValue: item.DataClassificationKey,
      }));
      setValue("ClientType", existingClientTypeDefaultList[0] || "", {
        shouldValidate: true,
      });
    } else {
      setValue("ClientType", "");
    }
  }, [clientSubAccountDataById?.DataClassificationKey, ClientTypeList]);

  /**IMP: onChange in client account ID, previously selected client codes should be cleared */
  const [myClientAccId, setMyClientAccId] = useState("");
  useEffect(() => {
    setMyClientAccId((prevVal) => {
      if (prevVal !== selectedClientAccId) {
        /**only for edit this condition is required */
        if (!!prevVal) {
          /**IMP action to clear client code data in text box and dialog*/
          setFinalCodeList([]);

          /**IMP: change in client account id, reset removeLogo state to false. */
          setRemoveLogo(false);
        }
      }
      return selectedClientAccId;
    });
  }, [selectedClientAccId]);

  /**setting default in code box */
  useEffect(() => {
    setClientCodes(finalCodeList, setValue);
  }, [finalCodeList, setValue]);

  /** !!!!!!! populating existing data in tables for this client account !!!!!! */
  useEffect(() => {
    if (!!clientSubAccountDataById) {
      /** */
      const existingClientUsers = clientSubAccountDataById?.ClientUserTeams;
      if (!!existingClientUsers) {
        setClientTeamTableData(existingClientUsers);
      }

      /** */
      const existingAccTeamMemberList =
        clientSubAccountDataById?.AccountUserTeams;
      if (!!existingAccTeamMemberList) {
        let list = [];
        existingAccTeamMemberList &&
          existingAccTeamMemberList.forEach((item) => {
            list.push({
              teamMemberId: item.StaffId,
              name: `${item.FirstName} ${item.LastName}`,
              email: item.EmailAddress,
              contact: item.ContactNo,
              jobPosition: item.JobPosition,
              bioId: item.BioId,
              bioTitle: item.TemplateTitle,
            });
          });
        setAccountTeamMemberTableData(list || []);
      }
    }
  }, [clientSubAccountDataById]);

  useEffect(() => {
    const existingClientadmins = clientSubAccountDataById?.ClientAccountAdmins;

    if (!!existingClientadmins) {
      let requiredAdminList = [];

      existingClientadmins.forEach((eachAdmin) => {
        const foundItem =
          !!accountAdminListFromAPI &&
          accountAdminListFromAPI.find(
            (item) => item.adminId === eachAdmin.adminId
          );

        if (!!foundItem) {
          requiredAdminList.push(foundItem);
        }
      });
      setAccountAdminTableData(requiredAdminList);
    }
  }, [clientSubAccountDataById, accountAdminListFromAPI]);

  /**remove logo */
  const [removeLogo, setRemoveLogo] = useState(false);

  /** !!!!!!!! submit handling !!!!!!! */
  const [bodyDataForUpdate, setBodyDataForUpdate] = useState({});
  const onSubmit = (data) => {
    /**primary and supportive language data transformation */
    const primLang = {
      IsPrimary: true,
      LanguageID: data.primary_lang?.id,
    };
    const supportedLangList =
      !!data.supported_lang &&
      data.supported_lang.map((item) => {
        return {
          IsPrimary: false,
          LanguageID: item?.id,
        };
      });

    const langList = [...supportedLangList, primLang];

    const codeList =
      !!finalCodeList &&
      finalCodeList.map((item) => {
        return {
          ClientCode: item.clientCode,
          ClientCodeName: item.clientCodeName,
        };
      });
    /** ClientUsersTeams AKA clientUsers data transformation */
    let clientUserList = [];
    if (!!clientTeamTableData) {
      const list = clientTeamTableData.map((item, index) => {
        return {
          Id: item.Id,
          /**array index+1 decides order to  show entries in table. order count starts from 1 to ...*/
          Orders: index + 1,
        };
      });
      clientUserList = !!list ? list : [];
    }

    /** AccountUserTeams AKA accountTeamMemmbers data transformation*/
    let accountTeamMembList = [];
    if (!!accountTeamMemberTableData) {
      const list = accountTeamMemberTableData.map((item, index) => {
        return {
          StaffId: item.teamMemberId,
          BioId: item.bioId,
          /**array index+1 decides order to  show entries in table. order count starts from 1 to ...*/
          Orders: index + 1,
        };
      });
      accountTeamMembList = !!list ? list : [];
    }

    /** clientAccountAdmins data transformation */
    let clientAccAdminList = [];
    if (!!accountAdminTableData) {
      const list = accountAdminTableData.map((item) => {
        return {
          adminId: item.adminId,
        };
      });
      clientAccAdminList = !!list ? list : [];
    }

    const body = {
      UserId: userId,
      ParentID: data?.client_acc_name?.id,
      Id: clientSubAccountId,
      ClientAccountName: data?.client_sub_acc_name || "",
      IsActive: true,
      UpdatedBy: userName || "",
      CurrencyId: data?.CurrencyId?.id,
      DataClassificationKey: data?.ClientType?.id,
      AccountLanguages: langList || [],
      ClientUserTeams: clientUserList || [],
      AccountUserTeams: accountTeamMembList || [],
      ClientAccountAdmins: clientAccAdminList || [],
      ClientAccountCodes: codeList || [],

      /***removeLogo is true then clear logo url */
      Logo: !!removeLogo ? "" : clientSubAccountDataById?.Logo,
    };
    setBodyDataForUpdate(body);

    if (!!data.logo_img[0]) {
      const file = data.logo_img[0];
      uploadLogo({ file });
    } else {
      updateClientSubAccount({ body, clientSubAccountId });
    }

    // console.log("subForm", data)
  };
  useEffect(() => {
    if (!!isSuccessOnLogoUpload) {
      const storedFileURL = dataOnLogoUpload.data.FileUrl;
      const bodyData = {
        ...bodyDataForUpdate,
        Logo: storedFileURL,
      };
      updateClientSubAccount({ body: bodyData, clientSubAccountId });
    }
  }, [isSuccessOnLogoUpload]);

  useEffect(() => {
    if (!!isSuccessOnUpdateCA || !!isSuccessOnDeleteCA) {
      navigate(clientSubAccountViewPath);
    }
  }, [isSuccessOnUpdateCA, isSuccessOnDeleteCA]);

  /** states from view All Client users */
  const [emailNotiSuccessFromViewDialog, setEmailNotiSuccessFromViewDialog] =
    useState(false);
  const [emailNotiErrorFromViewDialog, setEmailNotiErrorFromViewDialog] =
    useState(false);
  const [emailNotiLoadingFromViewDialog, setEmailNotiLoadingFromViewDialog] =
    useState(false);

  const [
    userActivationSuccessFromViewDialog,
    setUserActivationSuccessFromViewDialog,
  ] = useState(false);
  const [
    userActivationErrorFromViewDialog,
    setUserActivationErrorFromViewDialog,
  ] = useState(false);
  const [
    userActivationLoadingFromViewDialog,
    setUserActivationLoadingFromViewDialog,
  ] = useState(false);

  /**handling and processing for file download */
  const [fileDetails, setFileDetails] = useState({});

  const getFileDetailsFromFileURL = ({ fileURL }) => {
    const url = fileURL || "";

    const splitFileURL = url.split("/");

    const fileGUIDWithExtension = splitFileURL.at(-1);

    const fileGUIDWithExtensionSplit = fileGUIDWithExtension.split(".");

    const fileGUID = fileGUIDWithExtensionSplit[0] || "";
    const fileExtension = fileGUIDWithExtensionSplit[1] || "";

    return {
      fileGUID,
      fileExtension,
    };
  };

  const exisitngLogoFromSubAcc = clientSubAccountDataById?.Logo;
  /**parent client account logo */
  const logoFromParentClientAcc = dataOnClientAccountById?.Logo;

  const [logoNameToDiaplay, setLogoNameToDiaplay] = useState("");

  useEffect(() => {
    /**if parent client acc is changed, then change logo too as per parent */
    if (parentId !== selectedClientAccId) {
      const abc = getFileDetailsFromFileURL({
        fileURL: logoFromParentClientAcc,
      });

      setFileDetails({
        fileGUID: abc?.fileGUID || "",
        fileExtension: abc?.fileExtension || "",
      });
      setLogoNameToDiaplay(
        `${clientSubAccountDataById?.ClientAccountName}_logo (inherited)`
      );
    } else {
      const abc = getFileDetailsFromFileURL({
        fileURL: exisitngLogoFromSubAcc,
      });

      setFileDetails({
        fileGUID: abc?.fileGUID || "",
        fileExtension: abc?.fileExtension || "",
      });

      setLogoNameToDiaplay(
        `${clientSubAccountDataById?.ClientAccountName}_logo`
      );
    }
  }, [parentId, selectedClientAccId, logoFromParentClientAcc]);

  useEffect(() => {
    if (!!isSuccessOnDownload) {
      saveAs(
        dataOnDownload,
        `${clientSubAccountDataById?.ClientAccountName}_logo`
      );
    }
  }, [isSuccessOnDownload]);

  /**confirm dialog state on Activation/Deactivation action */
  const [
    openMpgConfirmDialogForAccAndSubAccount,
    setOpenMpgConfirmDialogForAccAndSubAccount,
  ] = useState(false);

  /**
   * disable fields and button
   */
  /**disable client acc name if user has A4 role and anot admin for parent client account */
  const [disabledClientAccName, setDisabledClientAccName] = useState(false);

  useEffect(() => {
    if (
      !!hasA4Access &&
      !clientSubAccountIdListForA4Role.includes(clientSubAccountDataById?.Id)
    ) {
      setDisabledClientAccName(true);
    } else {
      setDisabledClientAccName(false);
    }
  }, [hasA4Access, clientSubAccountIdListForA4Role]);

  /**disable update button  */
  const [disabledUpdateButton, setDisabledUpdateButton] = useState(false);
  useEffect(() => {
    /**if user has A4 role and not admin for this client sub account */
    if (
      !!hasA4Access &&
      !clientSubAccountIdListForA4Role.includes(clientSubAccountDataById?.Id)
    ) {
      setDisabledUpdateButton(true);
    } else {
      /**if subAcc is deactivated or its parent account is deactivated  */
      if (
        !clientSubAccountDataById?.ParentAccountIsActive ||
        !clientSubAccountDataById?.IsActive
      ) {
        setDisabledUpdateButton(true);
      } else {
        setDisabledUpdateButton(false);
      }
    }
  }, [hasA4Access, clientSubAccountIdListForA4Role, clientSubAccountDataById]);

  /**disable Deactivate/Reactivate button */
  const [
    disabledDeactivateReactivateButton,
    setDisabledDeactivateReactivateButton,
  ] = useState(false);

  useEffect(() => {
    /** a4 role where user is not admin for any clientSubAcc, then disable this button */
    if (
      !!hasA4Access &&
      !clientSubAccountIdListForA4Role.includes(clientSubAccountDataById?.Id)
    ) {
      setDisabledDeactivateReactivateButton(true);
    } else if (!clientSubAccountDataById?.ParentAccountIsActive) {
      /**if parent account is deactivated then disable this button */
      setDisabledDeactivateReactivateButton(true);
    } else {
      setDisabledDeactivateReactivateButton(false);
    }
  }, [hasA4Access, clientSubAccountIdListForA4Role]);

  /**tracking user Activity */
  const { trackActivity } = useTrackUserActivity();
  useEffect(() => {
    if (!!isSuccessOnDownload) {
      trackActivity({
        activitySuccess: !!isSuccessOnDownload,
        actionType: "Downloaded",
        itemId: fileDetails?.fileGUID || "",
      });
    }
    if (!!isSuccessOnDeleteCA) {
      let actionType = "";
      if (!!variablesOnDeleteCA?.isDeleteMode) {
        actionType = "Deactivated";
      } else if (!variablesOnDeleteCA?.isDeleteMode) {
        actionType = "Activated";
      }

      trackActivity({
        activitySuccess: !!isSuccessOnDeleteCA,
        actionType: actionType,
        itemId: clientSubAccountId || "",
      });
    }
    if (!!isSuccessOnLogoUpload) {
      const { fileGUID } = getGUIDAndExtentionFromFileURL({
        fileURL: dataOnLogoUpload?.data?.FileUrl,
      });

      trackActivity({
        activitySuccess: !!isSuccessOnLogoUpload,
        actionType: "Uploaded",
        itemId: fileGUID || "",
      });
    }
  }, [
    isSuccessOnDownload,
    clientSubAccountId,
    isSuccessOnDeleteCA,
    variablesOnDeleteCA,
    isSuccessOnLogoUpload,
  ]);

  /**handling error states and msgs */
  const [errorTitle, setErrorTitle] = useState("");
  const [errorContent, setErrorContent] = useState("");

  const fetchEditClientSubAccountCmsData = (key) => {
    if (
      refClientAccountCmsData?.Components &&
      refClientAccountCmsData?.Components[
        "ClientSubAccountDetails.SetupClientSubAccount"
      ]
    ) {
      const adminClientSubAccountCmsDataLabel =
        refClientAccountCmsData?.Components[
          "ClientSubAccountDetails.SetupClientSubAccount"
        ];
      return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key);
    }
    return "";
  };

  const fetchEditClientTeamMemberCmsData = (key) => {
    if (
      refClientAccountCmsData?.Components &&
      refClientAccountCmsData?.Components["ClientAccounts.ClientTeamMembers"]
    ) {
      const adminClientSubAccountCmsDataLabel =
        refClientAccountCmsData?.Components["ClientAccounts.ClientTeamMembers"];
      return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key);
    }
    return "";
  };

  const fetchEditAccountTeamMemberCmsData = (key) => {
    if (
      refClientAccountCmsData?.Components &&
      refClientAccountCmsData?.Components["ClientAccounts.AccountTeamMembers"]
    ) {
      const adminClientSubAccountCmsDataLabel =
        refClientAccountCmsData?.Components[
          "ClientAccounts.AccountTeamMembers"
        ];
      return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key);
    }
    return "";
  };

  const fetchAcountAdminCmsData = (key) => {
    if (
      refClientAccountCmsData?.Components &&
      refClientAccountCmsData?.Components["ClientAccounts.AccountAdmins"]
    ) {
      const adminClientSubAccountCmsDataLabel =
        refClientAccountCmsData?.Components["ClientAccounts.AccountAdmins"];
      return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key);
    }
    return "";
  };

  const returnLabel = (labelArray = [], key) => {
    return labelArray.find((x) => x.Key === key)?.Phrase || "";
  };

  useEffect(() => {
    if (
      !!isErrorOnUpdateCA &&
      errorOnUpdateCA?.response?.data === "NoAccessForA4Role"
    ) {
      setErrorTitle(
        fetchEditClientSubAccountCmsData(
          "ClientSubAccountDetails.WarningMsgUnauthorized"
        )
      );
      setErrorContent(
        fetchEditClientSubAccountCmsData(
          "ClientSubAccountDetails.ValidationMsgUnauthorized"
        )
      );
    } else if (
      !!isErrorOnUpdateCA &&
      errorOnUpdateCA?.response?.data === "AccountNameExists"
    ) {
      setErrorTitle("Sub-Account Name exists. Try again...!");
      setErrorContent(
        fetchEditClientSubAccountCmsData(
          "ClientSubAccountDetails.ValidationMsgDuplicateSubAccountName"
        ).replace("#CLIENT_ACCOUNT_NAME#", `"${watch("client_sub_acc_name")}"`)
      );
    } else {
      setErrorTitle("");
      setErrorContent("");
    }
  }, [isErrorOnUpdateCA, errorOnUpdateCA]);

  return (
    <Box sx={{ width: "100%" }}>
      {/* <CommonButtonHeader /> */}
      <Box sx={{ width: "100%" }}>
        <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
          {fetchEditClientSubAccountCmsData(
            "ClientSubAccountDetails.EditClientSubAccount"
          )}
        </Typography>

        {!clientSubAccountDataById?.ParentAccountIsActive && (
          <WarningAlert
            warningMsg={fetchEditClientSubAccountCmsData(
              "ClientSubAccountDetails.AccountDeactive"
            )}
          />
        )}

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          m={1}
        >
          <Button
            variant="outlined"
            size="small"
            component={Link}
            to={clientSubAccountViewPath}
          >
            {fetchEditClientSubAccountCmsData(
              "ClientSubAccountDetails.ClientSubAccounts"
            )}
          </Button>

          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setOpenAllClientUserNotiDialog(true);
            }}
          >
            {fetchEditClientSubAccountCmsData(
              "ClientSubAccountDetails.ViewAll"
            )}
          </Button>

          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setOpenMpgConfirmDialogForAccAndSubAccount(true);
            }}
            disabled={!!disabledDeactivateReactivateButton}
          >
            {!!clientSubAccountDataById?.IsActive
              ? fetchEditClientSubAccountCmsData(
                  "ClientSubAccountDetails.Deactivate"
                )
              : fetchEditClientSubAccountCmsData(
                  "ClientSubAccountDetails.Reactivate"
                )}
          </Button>
        </Stack>

        <Box
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
        >
          <Item>
            <Typography variant="h6" align="left" sx={{ fontWeight: "bolder" }}>
              {fetchEditClientSubAccountCmsData(
                "ClientSubAccountDetails.ClientAccountDetails"
              )}
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={"client_sub_acc_name"}
                  label={fetchEditClientSubAccountCmsData(
                    "ClientSubAccountDetails.SubAccountGroupName"
                  )}
                  fullWidth
                />

                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"client_acc_name"}
                  label={fetchEditClientSubAccountCmsData(
                    "ClientSubAccountDetails.ClientAccountName"
                  )}
                  fullWidth
                  optionList={clientAccAutocompleteList || []}
                  disabled={!!disabledClientAccName}
                />

                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"primary_lang"}
                  label={fetchEditClientSubAccountCmsData(
                    "ClientSubAccountDetails.PrimaryLanguages"
                  )}
                  fullWidth
                  optionList={primaryLangAutocompleteList || []}
                />
                <MpgAutocompleteMulti
                  rhfFormInstance={rhfFormInstance}
                  name={"supported_lang"}
                  label={fetchEditClientSubAccountCmsData(
                    "ClientSubAccountDetails.SupportedLanguages"
                  )}
                  fullWidth
                  optionList={supportiveLangAutocompleteList || []}
                  disabled={!selectedPrimaryLang?.id}
                />

                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"CurrencyId"}
                  label={fetchEditClientSubAccountCmsData(
                    "ClientSubAccountDetails.Currency"
                  )}
                  fullWidth
                  optionList={currencyAutocompleteList || []}
                />

                <MpgAutocompleteSingle
                  rhfFormInstance={rhfFormInstance}
                  name={"ClientType"}
                  label={"Type"}
                  fullWidth
                  optionList={ClientTypeAutocompleteList || []}
                />

                <Box>
                  <MpgFileUpload
                    name={"logo_img"}
                    label={fetchEditClientSubAccountCmsData(
                      "ClientSubAccountDetails.Logo"
                    )}
                    rhfFormInstance={rhfFormInstance}
                  />
                  {/** file download func */}
                  {!removeLogo && !!fileDetails?.fileGUID && (
                    <Grid>
                      <Tooltip title="Remove Logo">
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            setRemoveLogo(true);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                      <MuiLink
                        onClick={() => {
                          if (!!fileDetails?.fileGUID) {
                            downloadLogo({
                              fileGUID: fileDetails?.fileGUID,

                              /**DownloadType: "profileImage"|"logo"|"reportAndResources" */
                              DownloadType: "logo",
                              Extension: fileDetails?.fileExtension,
                            });
                          }
                        }}
                      >
                        {logoNameToDiaplay}
                      </MuiLink>
                    </Grid>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <div>
                  <MpgInput
                    rhfFormInstance={rhfFormInstance}
                    label={fetchEditClientSubAccountCmsData(
                      "ClientSubAccountDetails.ClientCodes"
                    )}
                    name={"client_codes"}
                    multiline
                    rows={10}
                    fullWidth
                    disabled={true}
                  />
                  {!!isFetchingOnClientCodeList && (
                    <Button disabled>
                      <CircularProgress size={15} sx={{ margin: "5px" }} />
                      {fetchEditClientSubAccountCmsData(
                        "ClientSubAccountDetails.Fetch"
                      )}
                    </Button>
                  )}
                  {!!isSuccessOnClientCodeList && !!selectedClientAccId && (
                    <Button
                      onClick={() => {
                        setOpenClientAccCodeDialog(true);
                      }}
                    >
                      {fetchEditClientSubAccountCmsData(
                        "ClientSubAccountDetails.SelectClientCodes"
                      )}
                    </Button>
                  )}
                </div>
                <Box sx={{ mt: 2 }}>
                  <MpgInput
                    rhfFormInstance={rhfFormInstance}
                    name={"created_by"}
                      label={fetchEditClientSubAccountCmsData(
                      "ClientSubAccountDetails.CreatedBy"
                    )}
                    fullWidth
                    disabled={true}
                  />
                </Box>

                <Box sx={{ mt: 2 }}>
                  <MpgInput
                    rhfFormInstance={rhfFormInstance}
                    name={"created_date"}
                      label={fetchEditClientSubAccountCmsData(
                      "ClientSubAccountDetails.CreatedDate"
                    )}
                    fullWidth
                    disabled={true}
                  />
                </Box>
              </Grid>
            </Grid>
          </Item>
          <br />
          <Item>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {refClientAccountCmsData?.Components &&
                  refClientAccountCmsData?.Components[
                    "ClientAccounts.ClientTeamMembers"
                  ]?.Title}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setOpenClientTeamDialog(true);
                }}
              >
                {fetchEditClientTeamMemberCmsData("ClientTeamMembers.Select")}
              </Button>
            </Stack>
            <ClientTeamTable
              tableData={clientTeamTableData || []}
              setTableData={setClientTeamTableData}
            />
          </Item>
          <br />
          <Item>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {refClientAccountCmsData?.Components &&
                  refClientAccountCmsData?.Components[
                    "ClientAccounts.AccountTeamMembers"
                  ]?.Title}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setOpenAccountTeamDialog(true);
                }}
              >
                {fetchEditAccountTeamMemberCmsData("AccountTeamMembers.Select")}
              </Button>
            </Stack>
            <AccountTeamTable
              tableData={accountTeamMemberTableData || []}
              setTableData={setAccountTeamMemberTableData}
              setWasAdminEdited={setWasAdminEdited}
            />
          </Item>
          <br />
          <Item
            sx={{
              border:
                rhfFormInstance.formState.errors.accountAdmins &&
                (rhfFormInstance.formState.isSubmitted || wasAdminEdited)
                  ? "1px solid red"
                  : undefined,
              borderRadius: 1,
              pb: 1,
            }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: "bolder" }}
              >
                {refClientAccountCmsData?.Components &&
                  refClientAccountCmsData?.Components[
                    "ClientAccounts.AccountAdmins"
                  ]?.Title}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setOpenAccountAdminDialog(true);
                }}
              >
                {fetchAcountAdminCmsData("AccountAdmins.Select")}
              </Button>
            </Stack>

            <AccountAdminTable
              tableData={accountAdminTableData || []}
              setTableData={setAccountAdminTableData}
              rhfFormInstance={rhfFormInstance}
              setWasAdminEdited={setWasAdminEdited}
            />

            {rhfFormInstance.formState.errors.accountAdmins &&
              (rhfFormInstance.formState.isSubmitted || wasAdminEdited) && (
                <Typography
                  color="error"
                  variant="caption"
                  align="left"
                  sx={{ px: 2, pt: 1 }}
                >
                  {rhfFormInstance.formState.errors.accountAdmins.message}
                </Typography>
              )}
          </Item>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent={"space-evenly"}
            mt={3}
          >
            <Button
              variant="contained"
              size="small"
              type="submit"
              sx={{ marginTop: "15px" }}
              disabled={!!disabledUpdateButton}
            >
              {fetchEditClientSubAccountCmsData(
                "ClientSubAccountDetails.UpdateClientAccount"
              )}
            </Button>
          </Stack>
        </Box>

        {/**all Dialogs */}
        <ClientTeamDialog
          open={openClientTeamDialog}
          setOpen={setOpenClientTeamDialog}
          clientTeamTableData={clientTeamTableData || []}
          setClientTeamTableData={setClientTeamTableData}
          clientUserListFromAPI={dataOnClientUsersWithParentUsers || []}
        />
        <AccountTeamMemberDialog
          open={openAccountTeamDialog}
          setOpen={setOpenAccountTeamDialog}
          accountTeamMemberTableData={accountTeamMemberTableData || []}
          setAccountTeamMemberTableData={setAccountTeamMemberTableData}
          accountTeamMembersListFromAPI={accountTeamMembersList || []}
        />
        <AccountAdminsDialog
          open={openAccountAdminDialog}
          setOpen={setOpenAccountAdminDialog}
          accountAdminTableData={accountAdminTableData || []}
          setAccountAdminTableData={setAccountAdminTableData}
          accountAdminListFromAPI={filteredAdminListArr || []}
        />
      </Box>

      <MpgClientCodeTransferListDialogForClientSubAcc
        transferDialogTitle={fetchEditClientSubAccountCmsData(
          "ClientSubAccountDetails.SelectClientCodes"
        )}
        leftTableTitle={fetchEditClientSubAccountCmsData(
          "ClientSubAccountDetails.AvailableClientCodes"
        )}
        rightTableTitle={fetchEditClientSubAccountCmsData(
          "ClientSubAccountDetails.SelectedClientCodes"
        )}
        open={openClientAccCodeDialog}
        setOpen={setOpenClientAccCodeDialog}
        grabRightTableData={setFinalCodeList}
        leftTableDataToPop={clientCodeListData || []}
        rightTableDataToPop={finalCodeList || []}
      />

      <ViewAllClientUserForNotiDialog
        open={openAllClientUserNotiDialog}
        setOpen={setOpenAllClientUserNotiDialog}
        clientAccOrSubAccName={
          clientSubAccountDataById?.ClientAccountName || ""
        }
        clientUserListFromAPI={dataOnGetClientUsers || []}
        refetchListFunc={refetchOnGetClientUsers}
        setEmailNotiSuccessFromViewDialog={setEmailNotiSuccessFromViewDialog}
        setEmailNotiErrorFromViewDialog={setEmailNotiErrorFromViewDialog}
        setEmailNotiLoadingFromViewDialog={setEmailNotiLoadingFromViewDialog}
        setUserActivationSuccessFromViewDialog={
          setUserActivationSuccessFromViewDialog
        }
        setUserActivationErrorFromViewDialog={
          setUserActivationErrorFromViewDialog
        }
        setUserActivationLoadingFromViewDialog={
          setUserActivationLoadingFromViewDialog
        }
        isDeactivated={
          !clientSubAccountDataById?.ParentAccountIsActive ||
          !clientSubAccountDataById?.IsActive
        }
      />

      {/** error dialog on update action */}
      <MpgErrorDialog
        open={
          !!isErrorOnUpdateCA ||
          !!isErrorOnLogoUpload ||
          !!isErrorOnDeleteCA ||
          !!emailNotiErrorFromViewDialog ||
          !!userActivationErrorFromViewDialog ||
          !!isErrorOnDownload
        }
        title={errorTitle || ""}
        content={errorContent || ""}
      />

      <MpgSuccessDialog
        open={
          !!emailNotiSuccessFromViewDialog ||
          !!userActivationSuccessFromViewDialog
        }
      />
      <MpgLoadingDialog
        open={
          !!emailNotiLoadingFromViewDialog ||
          !!userActivationLoadingFromViewDialog ||
          !!isLoadingOnUpdateCA ||
          !!isLoadingOnLogoUpload ||
          !!isLoadingOnDeleteCA
        }
      />

      {/** confirm dialog on delete action */}
      {!!clientSubAccountDataById?.IsActive && (
        <MpgConfirmDialogForAccAndSubAccount
          open={openMpgConfirmDialogForAccAndSubAccount}
          setOpen={setOpenMpgConfirmDialogForAccAndSubAccount}
          actionType={
            !!clientSubAccountDataById?.IsActive
              ? "DeactivateSubAccount"
              : "ActivateSubAccount"
          }
          handlerOnDeactivation={() => {
            const isActive = clientSubAccountDataById?.IsActive;
            if (!!isActive) {
              deleteClientSubAccountById({
                clientSubAccountId: clientSubAccountId,
                isDeleteMode: true,
                isClientAccount: false,
                isActivateAll: false,
              });
            }
          }}
        />
      )}
      {!clientSubAccountDataById?.IsActive && (
        <MpgConfirmDialogForAccAndSubAccount
          open={openMpgConfirmDialogForAccAndSubAccount}
          setOpen={setOpenMpgConfirmDialogForAccAndSubAccount}
          actionType={
            !!clientSubAccountDataById?.IsActive
              ? "DeactivateSubAccount"
              : "ActivateSubAccount"
          }
          handlerOnAccountOnlyActivation={() => {
            const isActive = clientSubAccountDataById?.IsActive;
            if (!isActive) {
              deleteClientSubAccountById({
                clientSubAccountId: clientSubAccountId,
                isDeleteMode: false,
                isClientAccount: false,
                isActivateAll: false,
              });
            }
          }}
          handlerOnAllActivation={() => {
            const isActive = clientSubAccountDataById?.IsActive;
            if (!isActive) {
              deleteClientSubAccountById({
                clientSubAccountId: clientSubAccountId,
                isDeleteMode: false,
                isClientAccount: false,
                isActivateAll: true,
              });
            }
          }}
        />
      )}
    </Box>
  );
};

export default EditClientSubAccount;
